import { Col, Row } from "reactstrap";
import "./Dashboard.css";
import styled from "styled-components";
// import PerformanceSearchBar from "utilFunctions/shared/PerformanceSearchBar";
import { useNavigate } from "react-router-dom";
import Typography from "Components/CommonComponents/Typography";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import RightArrow from "Assets/Icons/RightArrow";
import PDFViewIcon from "Assets/Icons/PDFViewIcon";
import MyLibraryUnselectedIcon from "Assets/Icons/MyLibraryUnselectedIcon";
import DashboardBatchesMain from "Pages/Dashboard/DashboardBatches/DashboardBatchesMain";
import { useContext, useEffect } from "react";
import { PushNotificationsMain } from "PushNotifications/PushNotificationsMain";
import { UserInfoContext } from "Context/CommonContext";
const DashboardMainRow: any = styled<any>("div")`
  background-color #E5F6FF;
  width: 100%;
  height: calc(100vh - 70px) !important;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 24px;
  margin-top: 12px;
  padding: ${(props: any) =>
    props.width > 1200
      ? "16px 20px 20px 47px"
      : ["xxl", "xl", "lg"].includes(props.screen)
      ? "0px 16px"
      : "0px"};
`;
const NotesDiv: any = styled<any>("div")`
  cursor: pointer;
  background: white;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "12px" : "12px"};
`;
const Dashboard = () => {
  const navigate = useNavigate();
  const userInfo = useContext<any>(UserInfoContext);
  const { screen, windowSize }: any = useWindowSize();
  const { width } = windowSize;
  //const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const handlePlannerRoute = (routeName: string) => {
    navigate("/admin/" + routeName, {
      replace: true,
      state: {
        selectedStudent: null,
      },
    });
  };
  useEffect(() => {
    PushNotificationsMain(userInfo);
    // window.scrollTo({
    //   top: 0,
    //   behavior: "smooth",
    // });
    // document.body.classList.add("noOverflow");
    // return () => {
    //   document.body.classList.remove("noOverflow");
    // };
  }, []);
  // const onRequestClose = () => {
  //   saveGlobalSearchData({
  //     pathurl: null,
  //     isBranchHealth: false,
  //     isStudentHealth: false,
  //     isPerformance: false,
  //   });
  // };
  return (
    <DashboardMainRow screen={screen} width={width}>
      {/* <Offcanvas
        backdrop={true}
        className="w-100 filterSlider"
        isOpen={globalSearchData?.isPerformance}
        direction="end"
        toggle={onRequestClose}
      >
        <OffcanvasHeader className="filterHeader w-100">
          <PerformanceSearchBar mode="mobilePerformance" />
        </OffcanvasHeader>
      </Offcanvas> */}
      {userInfo?.fexRole !== "Developer" ? (
        <Row>
          <DashboardBatchesMain screen={screen}></DashboardBatchesMain>
          <Col
            md="12"
            className={
              ["xxl", "xl", "lg"].includes(screen) ? "notesDiv" : "notesDivMB"
            }
          >
            <NotesDiv
              screen={screen}
              onClick={() => {
                handlePlannerRoute("planner");
              }}
            >
              <PDFViewIcon></PDFViewIcon>
              <div className="w-100 d-flex flex-column plannerRouteCard">
                <div className="w-100 d-flex flex-row justify-content-between align-items-center">
                  <Typography
                    variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                    color="darkgray"
                  >
                    Planners
                  </Typography>
                  <RightArrow className="cursorHoverCSS" />
                </div>
              </div>
            </NotesDiv>
            <NotesDiv
              screen={screen}
              onClick={() => {
                handlePlannerRoute("mylibrary");
              }}
            >
              <MyLibraryUnselectedIcon />
              <div className="w-100 d-flex flex-column plannerRouteCard">
                <div className="w-100 d-flex flex-row justify-content-between align-items-center">
                  <Typography
                    variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                    color="darkgray"
                  >
                    My Library
                  </Typography>
                  <RightArrow className="cursorHoverCSS" />
                </div>
              </div>
            </NotesDiv>
          </Col>
        </Row>
      ) : (
        <div className="w-100 d-flex flex-column plannerRouteCard">
          <div className="w-100 d-flex flex-row justify-content-between align-items-center">
            <Typography
              variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
              color="darkgray"
            >
              Welcome to the Developer Dashboard!
            </Typography>
          </div>
        </div>
      )}
      <div
        className={
          ["xxl", "xl", "lg"].includes(screen)
            ? "dashboardFooter"
            : "dashboardFooterMB"
        }
      >
        Empower minds, inspire endless growth 📚
      </div>
    </DashboardMainRow>
  );
};

export default Dashboard;
